// ═══════════════ PATRIMOINE - STATIC CONSTANTS ═══════════════
// Extracted from PatrimoinePage.js for maintainability.
// Pure data only — no React, no functions with side effects.

export const COLORS = ['#00e5a0', '#4f8eff', '#7c3aed', '#f97316', '#fbbf24', '#ec4899', '#06b6d4', '#84cc16'];
export const ACCOUNT_TYPES = ['PEA', 'CTO', 'Assurance Vie', 'Crypto', 'Autre'];
export const POS_TYPES = ['ETF', 'Action', 'Crypto', 'Autre'];
export const GEOS = ['Europe', 'USA', 'Asie', 'Amérique Latine', 'Afrique', 'Moyen-Orient', 'Océanie', 'Monde', 'Mixte'];
export const SECTORS = ['Tech', 'Santé', 'Finance', 'Énergie', 'Industrie', 'Conso', 'Multi-secteurs', 'Crypto', 'Immobilier', 'Utilities', 'Autre'];
export const RE_TYPES = ['Résidence principale', 'Locatif', 'Autre'];
export const ASSET_CATS = ['Véhicule', 'Montre', 'Art', 'Or', 'Autre'];

export const TICKER_DOMAIN_MAP = {
  'AAPL': 'apple.com', 'MSFT': 'microsoft.com', 'GOOGL': 'google.com', 'GOOG': 'google.com',
  'AMZN': 'amazon.com', 'TSLA': 'tesla.com', 'META': 'meta.com', 'NVDA': 'nvidia.com',
  'BNP': 'bnpparibas.com', 'SAN': 'santander.com', 'TTE': 'totalenergies.com',
  'AIR': 'airbus.com', 'SAF': 'safran-group.com', 'MC': 'lvmh.com', 'OR': 'loreal.com',
  'SU': 'schneider-electric.com', 'DG': 'vinci.com', 'AI': 'airliquide.com',
  'CW8': 'amundietf.com', 'ESE': 'bnpparibas-am.com', 'EWLD': 'lyxoretf.com',
  'SP500': 'spglobal.com', 'VOO': 'vanguard.com', 'SPY': 'ssga.com', 'QQQ': 'invesco.com',
  'NFLX': 'netflix.com', 'DIS': 'thewaltdisneycompany.com', 'PYPL': 'paypal.com',
  'INTC': 'intel.com', 'AMD': 'amd.com', 'CRM': 'salesforce.com', 'ADBE': 'adobe.com',
  'ORCL': 'oracle.com', 'CSCO': 'cisco.com', 'PEP': 'pepsico.com', 'KO': 'coca-colacompany.com',
  'MCD': 'mcdonalds.com', 'NKE': 'nike.com', 'V': 'visa.com', 'MA': 'mastercard.com',
  'JNJ': 'jnj.com', 'PFE': 'pfizer.com', 'UNH': 'unitedhealthgroup.com',
  'BA': 'boeing.com', 'CAT': 'caterpillar.com', 'GS': 'goldmansachs.com',
  'JPM': 'jpmorganchase.com', 'WMT': 'walmart.com', 'HD': 'homedepot.com',
  'RMS': 'hermes.com', 'CDI': 'christian-dior.com', 'KER': 'kering.com',
  'DSY': 'dassault-systemes.com', 'STM': 'st.com', 'CAP': 'capgemini.com',
  'EN': 'bouygues.com', 'VIE': 'veolia.com', 'ACA': 'credit-agricole.com',
  'GLE': 'societegenerale.com', 'CS': 'axa.com', 'SGO': 'saint-gobain.com',
  'RI': 'pernod-ricard.com', 'ORA': 'orange.com', 'ALO': 'alstom.com',
  'SOI': 'soitec.com', 'LR': 'legrand.com', 'SOP': 'sopragroup.com',
  'ENGI': 'engie.com', 'VIV': 'vivendi.com', 'PUB': 'publicisgroupe.com',
};

export const CRYPTO_MAP = {
  'BTC': 'bitcoin', 'ETH': 'ethereum', 'XRP': 'ripple', 'SOL': 'solana',
  'ADA': 'cardano', 'DOT': 'polkadot', 'AVAX': 'avalanche-2', 'MATIC': 'matic-network',
  'LINK': 'chainlink', 'UNI': 'uniswap', 'DOGE': 'dogecoin', 'SHIB': 'shiba-inu',
  'LTC': 'litecoin', 'ATOM': 'cosmos', 'FIL': 'filecoin', 'APT': 'aptos',
  'SUI': 'sui', 'NEAR': 'near', 'ARB': 'arbitrum', 'OP': 'optimism',
  'BNB': 'binancecoin', 'TRX': 'tron', 'XLM': 'stellar', 'ALGO': 'algorand',
  'ICP': 'internet-computer', 'FTM': 'fantom', 'SAND': 'the-sandbox', 'MANA': 'decentraland',
  'AAVE': 'aave', 'MKR': 'maker', 'CRV': 'curve-dao-token', 'PEPE': 'pepe',
};

export const INSTITUTIONS = [
  { name: 'Bourse Direct', domain: 'boursedirect.fr', cat: 'Courtier' },
  { name: 'Interactive Brokers', domain: 'interactivebrokers.com', cat: 'Courtier' },
  { name: 'Degiro', domain: 'degiro.fr', cat: 'Courtier' },
  { name: 'Trade Republic', domain: 'traderepublic.com', cat: 'Courtier' },
  { name: 'Boursorama Banque', domain: 'boursorama.com', cat: 'Courtier' },
  { name: 'Fortuneo', domain: 'fortuneo.fr', cat: 'Courtier' },
  { name: 'XTB', domain: 'xtb.com', cat: 'Courtier' },
  { name: 'Saxo Banque', domain: 'home.saxo', cat: 'Courtier' },
  { name: 'Yomoni', domain: 'yomoni.fr', cat: 'Courtier' },
  { name: 'Hello Bank', domain: 'hellobank.fr', cat: 'Courtier' },
  { name: 'Binance', domain: 'binance.com', cat: 'Crypto' },
  { name: 'MEXC', domain: 'mexc.com', cat: 'Crypto' },
  { name: 'Coinbase', domain: 'coinbase.com', cat: 'Crypto' },
  { name: 'Kraken', domain: 'kraken.com', cat: 'Crypto' },
  { name: 'Bitpanda', domain: 'bitpanda.com', cat: 'Crypto' },
  { name: 'Bitget', domain: 'bitget.com', cat: 'Crypto' },
  { name: 'Crypto.com', domain: 'crypto.com', cat: 'Crypto' },
  { name: 'Coinhouse', domain: 'coinhouse.com', cat: 'Crypto' },
  { name: 'Crédit Agricole', domain: 'creditagricole.fr', cat: 'Banque' },
  { name: 'BNP Paribas', domain: 'bnpparibas.fr', cat: 'Banque' },
  { name: 'Société Générale', domain: 'societegenerale.fr', cat: 'Banque' },
  { name: 'La Banque Postale', domain: 'labanquepostale.fr', cat: 'Banque' },
  { name: "Caisse d'Épargne", domain: 'caisse-epargne.fr', cat: 'Banque' },
  { name: 'Crédit Mutuel', domain: 'creditmutuel.fr', cat: 'Banque' },
  { name: 'Banque Populaire', domain: 'banquepopulaire.fr', cat: 'Banque' },
  { name: 'CIC', domain: 'cic.fr', cat: 'Banque' },
  { name: 'LCL', domain: 'lcl.fr', cat: 'Banque' },
  { name: 'Revolut', domain: 'revolut.com', cat: 'Banque' },
  { name: 'Boursobanque', domain: 'boursobank.com', cat: 'Banque' },
];

export const BANQUES_FR = [
  { name: 'Crédit Agricole', domain: 'creditagricole.fr', cat: 'Banque traditionnelle' },
  { name: 'BNP Paribas', domain: 'bnpparibas.fr', cat: 'Banque traditionnelle' },
  { name: 'Société Générale', domain: 'societegenerale.fr', cat: 'Banque traditionnelle' },
  { name: "Caisse d'Épargne", domain: 'caisse-epargne.fr', cat: 'Banque traditionnelle' },
  { name: 'Banque Populaire', domain: 'banquepopulaire.fr', cat: 'Banque traditionnelle' },
  { name: 'Crédit Mutuel', domain: 'creditmutuel.fr', cat: 'Banque traditionnelle' },
  { name: 'CIC', domain: 'cic.fr', cat: 'Banque traditionnelle' },
  { name: 'La Banque Postale', domain: 'labanquepostale.fr', cat: 'Banque traditionnelle' },
  { name: 'LCL', domain: 'lcl.fr', cat: 'Banque traditionnelle' },
  { name: 'HSBC France', domain: 'hsbc.fr', cat: 'Banque traditionnelle' },
  { name: 'Boursobanque', domain: 'boursobank.com', cat: 'Banque en ligne' },
  { name: 'Hello Bank', domain: 'hellobank.fr', cat: 'Banque en ligne' },
  { name: 'Fortuneo', domain: 'fortuneo.fr', cat: 'Banque en ligne' },
  { name: 'Monabanq', domain: 'monabanq.com', cat: 'Banque en ligne' },
  { name: 'BforBank', domain: 'bforbank.com', cat: 'Banque en ligne' },
  { name: 'Orange Bank', domain: 'orangebank.fr', cat: 'Banque en ligne' },
  { name: 'N26', domain: 'n26.com', cat: 'Banque en ligne' },
  { name: 'Revolut', domain: 'revolut.com', cat: 'Banque en ligne' },
  { name: 'Trade Republic', domain: 'traderepublic.com', cat: 'Banque en ligne' },
];

export const EPARGNE_SALARIALE_INSTITUTIONS = [
  { name: 'Amundi', domain: 'amundi-ee.com', cat: 'Épargne salariale' },
  { name: 'BNP Paribas Épargne & Retraite', domain: 'bnpparibas-ee.com', cat: 'Épargne salariale' },
  { name: 'Natixis Interépargne', domain: 'interepargne.natixis.com', cat: 'Épargne salariale' },
  { name: 'Crédit Agricole (Eres)', domain: 'eres-group.com', cat: 'Épargne salariale' },
  { name: 'AXA Épargne Entreprise', domain: 'axa.fr', cat: 'Épargne salariale' },
  { name: 'Société Générale', domain: 'societegenerale.fr', cat: 'Épargne salariale' },
  { name: 'Groupama Épargne Salariale', domain: 'groupama-es.fr', cat: 'Épargne salariale' },
];

export const TYPES_EPARGNE_PERSONNELLE = ['Compte courant', 'Livret A', 'LDDS', 'LEP', 'PEL', 'CEL', 'PER', 'Assurance-vie fonds euros', 'Autre'];
export const TYPES_EPARGNE_SALARIALE = ['PEE', 'PERCOL', 'PEG', 'Autre'];

export const CRYPTO_PLATFORMS = [
  { name: 'Binance', domain: 'binance.com', cat: 'Exchange' },
  { name: 'Coinbase', domain: 'coinbase.com', cat: 'Exchange' },
  { name: 'Kraken', domain: 'kraken.com', cat: 'Exchange' },
  { name: 'Bitpanda', domain: 'bitpanda.com', cat: 'Exchange' },
  { name: 'Crypto.com', domain: 'crypto.com', cat: 'Exchange' },
  { name: 'Bybit', domain: 'bybit.com', cat: 'Exchange' },
  { name: 'OKX', domain: 'okx.com', cat: 'Exchange' },
  { name: 'Ledger', domain: 'ledger.com', cat: 'Hardware wallet' },
  { name: 'Metamask', domain: 'metamask.io', cat: 'Wallet' },
];

export const ASSURANCE_VIE_PROVIDERS = [
  { name: 'Linxea', domain: 'linxea.com', cat: 'Courtier spécialisé' },
  { name: 'Lucya Cardif (BNP Paribas)', domain: 'cardif.fr', cat: 'Assureur' },
  { name: 'Spirica (Crédit Agricole)', domain: 'spirica.fr', cat: 'Assureur' },
  { name: 'Generali', domain: 'generali.fr', cat: 'Assureur' },
  { name: 'Swiss Life', domain: 'swisslife.fr', cat: 'Assureur' },
  { name: 'AXA', domain: 'axa.fr', cat: 'Assureur' },
  { name: 'Boursorama Banque', domain: 'boursobank.com', cat: 'Banque' },
  { name: 'Fortuneo', domain: 'fortuneo.fr', cat: 'Banque' },
  { name: 'Société Générale', domain: 'societegenerale.fr', cat: 'Banque' },
  { name: 'Crédit Mutuel', domain: 'creditmutuel.fr', cat: 'Banque' },
  { name: "Caisse d'Épargne", domain: 'caisse-epargne.fr', cat: 'Banque' },
  { name: 'La Banque Postale', domain: 'labanquepostale.fr', cat: 'Banque' },
];

// Aggregated name → domain map across every institution list, populated once.
export const BROKER_MAP = {};
[INSTITUTIONS, BANQUES_FR, EPARGNE_SALARIALE_INSTITUTIONS, CRYPTO_PLATFORMS, ASSURANCE_VIE_PROVIDERS]
  .forEach(list => list.forEach(i => {
    BROKER_MAP[i.name] = i.domain;
    BROKER_MAP[i.name.toLowerCase()] = i.domain;
  }));

export const DEBT_TYPE_MAP = { immobilier: 'Logement', consommation: 'Crédit', auto: 'Crédit', etudiant: 'Crédit', autre: 'Crédit' };
